// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__LM_RH","upload":"Small_upload__3IvD6","imageWrap":"Small_imageWrap__2V1Td","removeBtn":"Small_removeBtn__3Vzxa"};